import { createAction } from 'typesafe-actions';

import { CollectionActions } from '../constants/Collection';

interface AddCollectionItemParams {
  pandoraId: $TSFixMe;
  pandoraType: $TSFixMe;
  stationId: $TSFixMe;
}

export const addCollectionItem = createAction(
  CollectionActions.ADD_COLLECTION_ITEM,
  (params: AddCollectionItemParams) => params,
)<AddCollectionItemParams>();
export type AddCollectionItemAction = ReturnType<typeof addCollectionItem>;

interface RemoveCollectionItemParams {
  componentName: $TSFixMe;
  pandoraId: $TSFixMe;
  pandoraType: $TSFixMe;
  redirectToMyMusic: $TSFixMe;
  redirectToMyMusicPlaylists: $TSFixMe;
  stationId: $TSFixMe;
}

export const removeCollectionItem = createAction(
  CollectionActions.REMOVE_COLLECTION_ITEM,
  (params: $TSFixMe) => params,
)<RemoveCollectionItemParams>();
export type RemoveCollectionItemAction = ReturnType<typeof removeCollectionItem>;

export const getVersion = createAction(CollectionActions.GET_COLLECTION_VERSION)();
export type GetCollectionVersionAction = ReturnType<typeof getVersion>;

interface RemoveStationFromCollectionParams {
  componentName: $TSFixMe;
  redirectToMyMusic: $TSFixMe;
  stationId: $TSFixMe;
}

export const confirmRemoveStationFromCollection = createAction(
  CollectionActions.REMOVE_STATION_FROM_COLLECTION,
  (params: $TSFixMe) => params,
)<RemoveStationFromCollectionParams>();
export type RemoveStationFromCollectionAction = ReturnType<
  typeof confirmRemoveStationFromCollection
>;

interface GetCollectionSortedItemsParams {
  annotationLimit: $TSFixMe;
  filter: $TSFixMe;
  limit: $TSFixMe;
  offset: $TSFixMe;
  sortOrder: $TSFixMe;
}

export const getSortedCollectionItems = createAction(
  CollectionActions.GET_COLLECTION_SORTED_ITEMS,
  (params: GetCollectionSortedItemsParams) => params,
)<GetCollectionSortedItemsParams>();
export type GetCollectionSortedItemsAction = ReturnType<typeof getSortedCollectionItems>;

interface SetCollectionCurrentFilterPayload {
  filter: $TSFixMe;
}

export const setCollectionCurrentFilter = createAction(
  CollectionActions.SET_COLLECTION_CURRENT_FILTER,
  (filter: $TSFixMe) => ({ filter }),
)<SetCollectionCurrentFilterPayload>();
export type SetCollectionCurrentFilterAction = ReturnType<typeof setCollectionCurrentFilter>;

interface GetCollectionItemsByArtistParams {
  annotationLimit: $TSFixMe;
  artistPandoraId: $TSFixMe;
}

export const getItemsByArtist = createAction(
  CollectionActions.GET_COLLECTION_ITEMS_BY_ARTIST,
  (params: GetCollectionItemsByArtistParams) => params,
)<GetCollectionItemsByArtistParams>();
export type GetCollectionItemsByArtistAction = ReturnType<typeof getItemsByArtist>;

interface SetCollectionCurrentFilterSortParams {
  newDisplayType: string;
  sort: string;
}

/**
 *
 * @param {string} sort The persisted sorting value ('ALPHA', 'MOST_RECENT_ADDED', etc)
 * @param {string} newDisplayType A value consumed by onCollectionListSorted worker saga and dispatched to logEvents for sorting analytics
 */
export const setCollectionCurrentFilterSort = createAction(
  CollectionActions.SET_COLLECTION_CURRENT_FILTER_SORT,
  (params: SetCollectionCurrentFilterSortParams) => params,
)<SetCollectionCurrentFilterSortParams>();
export type SetCollectionCurrentFilterSortAction = ReturnType<
  typeof setCollectionCurrentFilterSort
>;
